var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVitaminsAndMinerals = function SvgVitaminsAndMinerals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m17.278 6.627.563.562a4 4 0 0 1-.66 6.19l-6.797 4.385m6.894-11.137-.494-.495a4 4 0 0 0-6.23.723l-.236.38m6.96-.608 5.127-.53m-5.127.53.53-5.127m-.53 5.127 4.243-4.243M10.318 7.236l2.645 2.645m-2.645-2.645L8.791 9.704m0 0-6.8 10.982c-.616.997.547 2.14 1.532 1.504l6.861-4.427m-1.593-8.06 1.82 1.822m-.227 6.239-1.59-1.591"
  })));
};
export default SvgVitaminsAndMinerals;